<template>
  <v-app>
    <v-container fluid class="pa-0">
      <v-form @submit.prevent="submit">
        <v-row class="mt-3">
          <v-col cols="12">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                  Production Order Information
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-card flat>
                    <v-card-text>
                      <v-row dense>
                        <v-col cols="4">
                          <v-autocomplete
                            v-model="buyer_order_id.value.value"
                            :items="$store.getters.getBuyerOrderList"
                            :item-title="item => `${item.code ?? ''} - ${item.buyer?.company_name ?? ''}`"
                            :item-value="item => item.id ?? null"
                            variant="outlined"
                            density="compact"
                            label="Buyer Order *"
                            :error-messages="buyer_order_id.errorMessage.value"
                            clearable
                            @update:model-value="onBuyerOrderChange"
                          />
                        </v-col>

                        <v-col cols="4">
                          <v-autocomplete
                            v-model="factory_id.value.value"
                            :items="$store.getters.getSupplierList"
                            :item-title="item => `${item.supplier_name ?? ''} - ${item.code ?? ''}`"
                            :item-value="item => item.id ?? null"
                            variant="outlined"
                            density="compact"
                            label="Factory *"
                            :error-messages="factory_id.errorMessage.value"
                            clearable
                          />
                        </v-col>

                        <v-col cols="4">
                          <v-date-input
                            v-model="allocation_date.value.value"
                            label="Allocation Date *"
                            variant="outlined"
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            :error-messages="allocation_date.errorMessage.value"
                            clearable
                          />
                        </v-col>

                        <v-col cols="4">
                          <v-date-input
                            v-model="ex_factory_date.value.value"
                            label="Ex Factory Date"
                            variant="outlined"
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            :error-messages="ex_factory_date.errorMessage.value"
                            clearable
                          />
                        </v-col>

                        <v-col cols="4">
                          <v-date-input
                            v-model="shipment_date.value.value"
                            label="Shipment Date"
                            variant="outlined"
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            :error-messages="shipment_date.errorMessage.value"
                            clearable
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <v-col cols="12" >
            <v-row>
              <v-col cols="12">
                <v-expansion-panels v-model="panel2" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                      Production Order Items
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                      <v-card flat>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" class="pa-0">
                              <v-expansion-panels multiple>
                                <v-expansion-panel
                                  v-for="(item, i) in items"
                                  :key="i"
                                >
                                  <v-expansion-panel-title style="padding:10px 3px; background-color:#cfd8dc;">
                                    <table style="width:100%; font-size:13px; border-collapse:collapse;">
                                      <tbody>
                                        <tr>
                                          <td style="padding: 0px 5px;">
                                            <v-autocomplete
                                              variant="outlined"
                                              density="compact"
                                              label="Style*"
                                              bg-color="grey-lighten-4"
                                              v-model="item.style_id"
                                              :items="getProductionStyleList"
                                              :item-title="(it) => `${it?.code}`"
                                              item-value="id"
                                              autocomplete="off"
                                              hide-details
                                              clearable
                                              :loading="loadingBuyerOrder"
                                              :disabled="loadingBuyerOrder || !buyer_order_id.value.value"
                                              :readonly="true"
                                              @update:model-value="onItemChange(i)"
                                              @click.stop
                                              @mousedown.stop
                                            ></v-autocomplete>
                                          </td>

                                          <td style="width:18%; padding: 0px 5px;">
                                            <v-text-field
                                              @click.stop
                                              @mousedown.stop
                                              v-model="item.order_quantity"
                                              type="number"
                                              min="0"
                                              step="1"
                                              variant="outlined"
                                              density="compact"
                                              label="Order Quantity*"
                                              class="text-right"
                                              hide-details
                                            ></v-text-field>
                                          </td>

                                          <!-- <td style="width:18%; padding: 0px 5px;">
                                            <v-text-field
                                              @click.stop
                                              @mousedown.stop
                                              v-model="item.unit_price"
                                              type="number"
                                              min="0"
                                              step="0.01"
                                              variant="outlined"
                                              density="compact"
                                              label="Unit price*"
                                              class="text-right"
                                              @input="onItemUnitPriceChange(i)"
                                              hide-details
                                            ></v-text-field>
                                          </td> -->

                                          <td style="width:18%; padding: 0px 5px;">
                                            <v-text-field
                                              @click.stop
                                              @mousedown.stop
                                              v-model="item.total_value"
                                              type="number"
                                              min="0"
                                              step="0.01"
                                              variant="outlined"
                                              density="compact"
                                              label="Total value*"
                                              class="text-right"
                                              hide-details
                                              readonly
                                            ></v-text-field>
                                          </td>

                                          <td style="width: 90px; text-align:right">
                                            <!-- <v-btn @click.stop @mousedown.stop v-if="i == items.length - 1" variant="tonal" icon size="small" color="primary" @click="addItem">
                                              <v-icon color="blue">mdi-plus</v-icon>
                                            </v-btn> -->
                                            <v-btn @click.stop @mousedown.stop v-if="(i != items.length - 1) || (items.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1" @click="removeItem(i)">
                                              <v-icon color="red">mdi-close</v-icon>
                                            </v-btn>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </v-expansion-panel-title>

                                  <v-expansion-panel-text style="padding:5px 20px;">
                                    <table style="width:100%; margin-top:10px; font-size:13px; border-collapse:collapse;">
                                      <!-- <thead>
                                        <tr style="background-color: #f5f5f5;">
                                          <th style="padding: 8px; text-align: left;">Color</th>
                                          <th style="padding: 8px; text-align: left;">Size</th>
                                          <th style="padding: 8px; ">Remaining</th>
                                          <th style="padding: 8px; ">Quantity</th>
                                          <th style="padding: 8px; ">Unit Price</th>
                                          <th style="padding: 8px; ">Total Price</th>
                                          <th style="padding: 8px; ">Consumption</th>
                                          <th style="padding: 8px; ">Action</th>
                                        </tr>
                                      </thead> -->
                                      <tbody>
                                        <tr
                                          v-for="(bd, bi) in item.breakdowns"
                                          :key="bi"
                                        >
                                          <td style="width:20%; padding: 0px 5px;">
                                            <v-autocomplete
                                              class="mt-2"
                                              variant="outlined"
                                              density="compact"
                                              label="Color*"
                                              bg-color="grey-lighten-4"
                                              v-model="bd.color_id"
                                              :items="getProductionColorList"
                                              :item-title="(it) => `${it.name ?? ''} ${it.code ? '(' + it.code + ')' : ''}`"
                                              item-value="id"
                                              autocomplete="off"
                                              hide-details
                                              clearable
                                              :readonly="true"
                                              @update:model-value="onBreakdownChange(i, bi)"
                                            ></v-autocomplete>
                                          </td>

                                          <td style="width:20%; padding: 0px 5px;">
                                            <v-autocomplete
                                              class="mt-2"
                                              variant="outlined"
                                              density="compact"
                                              label="Size*"
                                              bg-color="grey-lighten-4"
                                              v-model="bd.size_id"
                                              :items="getProductionSizeList"
                                              :item-title="(it) => `${it.name ?? ''} ${it.code ? '(' + it.code + ')' : ''}`"
                                              item-value="id"
                                              autocomplete="off"
                                              hide-details
                                              clearable
                                              :readonly="true"
                                              @update:model-value="onBreakdownChange(i, bi)"
                                            ></v-autocomplete>
                                          </td>

                                          <td style="padding: 0px 5px; text-align: right;">
                                            <v-text-field
                                              v-model="bd.remaining_qty"
                                              label="Remaining"
                                              type="number"
                                              variant="outlined"
                                              density="compact"
                                              class="text-right mt-2"
                                              hide-details
                                              readonly
                                              hide-spin-buttons
                                              bg-color="grey-lighten-4"
                                            />
                                          </td>

                                          <td style="padding: 0px 5px;">
                                            <v-text-field
                                              v-model.number="bd.quantity"
                                              label="Quantity*"
                                              type="number"
                                              min="0"
                                              step="1"
                                              variant="outlined"
                                              density="compact"
                                              class="text-right mt-2"
                                              hide-details
                                              hide-spin-buttons
                                              @input="onItemBreakdownCalculationChange(i, bi)"
                                            />
                                          </td>

                                          <td style="padding: 0px 5px;">
                                            <v-text-field
                                              v-model.number="bd.unit_price"
                                              type="number"
                                              min="0"
                                              step="0.01"
                                              variant="outlined"
                                              density="compact"
                                              label="Unit price*"
                                              class="text-right mt-2"
                                              hide-spin-buttons
                                              hide-details
                                              @input="onItemBreakdownCalculationChange(i, bi)"
                                            />
                                          </td>

                                          <td style="padding: 0px 5px;">
                                            <v-text-field
                                              v-model.number="bd.total_price"
                                              type="number"
                                              min="0"
                                              step="0.01"
                                              variant="outlined"
                                              density="compact"
                                              label="Total price*"
                                              class="text-right mt-2"
                                              hide-spin-buttons
                                              hide-details
                                              readonly
                                            />
                                          </td>

                                          <td style="padding: 0px 5px;">
                                            <v-text-field
                                              v-model.number="bd.consumption"
                                              type="number"
                                              min="0"
                                              step="0.01"
                                              variant="outlined"
                                              density="compact"
                                              label="Consumption*"
                                              class="text-right mt-2"
                                              hide-spin-buttons
                                              hide-details
                                            />
                                          </td>

                                          <td style="width: 90px; padding: 0px 5px;">
                                            <!-- <v-btn v-if="bi == (item.breakdowns).length - 1" variant="tonal" icon size="small" color="primary" @click="addBreakdown(i)">
                                              <v-icon color="blue">mdi-plus</v-icon>
                                            </v-btn> -->
                                            <v-btn v-if="(bi != (item.breakdowns).length - 1) || ((item.breakdowns).length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1" @click="removeBreakdown(i, bi)">
                                              <v-icon color="red">mdi-close</v-icon>
                                            </v-btn>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </v-expansion-panel-text>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <v-divider class=""></v-divider>
            <v-card-actions class="justify-end">
              <v-btn color="white" class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
              <v-btn color="primary" variant="flat" type="button" @click="submitForm(1)" class="ms-2">
                {{ isEntryMode ? 'Save' : 'Update' }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script>
import { ref, onMounted, computed, watch, nextTick } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import { useRoute, useRouter } from "vue-router";

export default {
  created() {
    this.loading = true;
    this.$store.dispatch('getBuyerOrderList').then((response) => {
      this.loading = false;
    });

    this.loading = true;
    this.$store.dispatch('getProductionStyleList').then((response) => {
      this.loading = false;
    });

    this.loading = true;
    this.$store.dispatch('getSupplierList', {}).then((response) => {
      this.loading = false;
    });

    this.loading = true;
    this.$store.dispatch('getProductionColorList').then((response) => {
      this.loading = false;
    });

    this.loading = true;
    this.$store.dispatch('getProductionSizeList').then((response) => {
      this.loading = false;
    });
  },

  computed: {
    getProductionStyleList() {
        return this.$store.getters.getProductionStyleList;
    },

    getProductionSizeList(){
      return this.$store.getters.getProductionSizeList;
    },

    getProductionColorList(){
      return this.$store.getters.getProductionColorList;
    },
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const panel = ref([0]);
    const panel2 = ref([0]);
    const isEntryMode = ref(true);
    const selectedBuyerOrder = ref(null);
    const loadingBuyerOrder = ref(false);

    const items = ref([
      {
        buyer_order_item_id: null,
        style_id: null,
        order_quantity: 0,
        // unit_price: 0,
        total_value: 0,
        breakdowns: [
          {
            buyer_order_breakdown_id: null,
            color_id: null,
            size_id: null,
            quantity: 0,
            unit_price: 0,
            total_price:0,
            consumption: 0,
            remaining_qty: 0,
          }
        ]
      }
    ]);

    const { handleSubmit, resetForm, setValues, setFieldValue, errors } = useForm({
      initialValues: {
        buyer_order_id: null,
        factory_id: null,
        allocation_date: null,
        ex_factory_date: null,
        shipment_date: null,
        status: 1,
        items: [{
          buyer_order_item_id: null,
          style_id: null,
          order_quantity: 0,
          // unit_price: 0,
          total_value: 0,
          breakdowns: [{
            buyer_order_breakdown_id: null,
            color_id: null,
            size_id: null,
            quantity: 0,
            unit_price: 0,
            total_price:0,
            consumption: 0,
          }]
        }],
      },
      validationSchema: yup.object({
        buyer_order_id: yup.number().required("Buyer order is required"),
        factory_id: yup.number().required("Factory is required"),
        allocation_date: yup.date().required("Allocation date is required"),
        ex_factory_date: yup.date().nullable(),
        shipment_date: yup.date().nullable(),
        status: yup.number().oneOf([0, 1], "Status must be 0 or 1").required("Status is required"),
      }),
    });

    const buyer_order_id = useField("buyer_order_id");
    const factory_id = useField("factory_id");
    const allocation_date = useField("allocation_date");
    const ex_factory_date = useField("ex_factory_date");
    const shipment_date = useField("shipment_date");


    const submitForm = (status) => {
        setFieldValue('status', status);
        submit();                       
      };

    const getAvailableBuyerOrderItems = computed(() => {
      // Placeholder - functionality to be implemented later
      return [];
    });

    const getAvailableBreakdownsForItem = (itemIndex) => {
      // Placeholder - functionality to be implemented later
      return [];
    };

    const getAvailableColorsForItem = (itemIndex) => {
      // Placeholder - functionality to be implemented later
      return [];
    };

    const getAvailableSizesForItem = (itemIndex) => {
      // Placeholder - functionality to be implemented later
      return [];
    };

    const onBuyerOrderChange = (id) => {
      if (!id) {
        items.value = [{
          id:null,
          buyer_order_item_id: null,
          style_id: null,
          order_quantity: 0,
          // unit_price: 0,
          total_value: 0,
          breakdowns: [{
            id:null,
            buyer_order_breakdown_id: null,
            color_id: null,
            size_id: null,
            quantity: 0,
            unit_price: 0,
            total_price:0,
            consumption: 0,
            remaining_qty: 0,
          }]
        }];
        selectedBuyerOrder.value = null;
        return;
      }

      store.dispatch("getBuyerOrderById", { id })
      .then((res) => {
        const data = res.data.data;
        selectedBuyerOrder.value = data;

        items.value = data.items.map(i => ({
          id:null,
          buyer_order_item_id: i.id,
          style_id: i.style_id,
          order_quantity: i.order_quantity,
          // unit_price: i.unit_price,
          total_value: i.total_value,
          breakdowns: i.breakdowns.map(b => ({
            id:null,
            buyer_order_breakdown_id: b.id,
            size_id: b.size_id,
            color_id: b.color_id,
            quantity: b.remaining_qty,
            remaining_qty: b.remaining_qty,
            unit_price: b.unit_price,
            total_price: b.unit_price * b.quantity,
            consumption: b.consumption,
          }))
        }));

      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to load Buyer Order");
      });

      loadingBuyerOrder.value = false;
    };

    const onItemChange = (itemIndex) => {
      // Placeholder - functionality to be implemented later
      console.log('Item changed at index:', itemIndex);
    };

    const findAndLoadBuyerOrderItem = (itemIndex, buyerOrder) => {
      // Placeholder - functionality to be implemented later
      console.log('Finding buyer order item:', itemIndex, buyerOrder);
    };

    const onBreakdownChange = (itemIndex, breakdownIndex) => {
      const item = items.value[itemIndex];
      const breakdown = item.breakdowns[breakdownIndex];
      
      if (!breakdown.color_id || !breakdown.size_id) return;

      // First check if we have the selected buyer order with items
      let buyerOrder = selectedBuyerOrder.value;
      
      // Fallback to checking the list
      if (!buyerOrder || !buyerOrder.items) {
        const buyerOrderId = buyer_order_id.value.value;
        if (!buyerOrderId) return;
        
        buyerOrder = store.getters.getBuyerOrderList.find(bo => bo.id === buyerOrderId);
      }

      if (!buyerOrder || !buyerOrder.items) return;

      const buyerOrderItem = buyerOrder.items.find(i => i.id === item.buyer_order_item_id);
      if (!buyerOrderItem || !buyerOrderItem.breakdowns) return;

      const buyerBreakdown = buyerOrderItem.breakdowns.find(
        bd => bd.color_id === breakdown.color_id && bd.size_id === breakdown.size_id
      );

      if (buyerBreakdown) {
        breakdown.buyer_order_breakdown_id = buyerBreakdown.id;
        breakdown.remaining_qty = buyerBreakdown.remaining_qty;
        breakdown.unit_price = buyerBreakdown.unit_price || breakdown.unit_price;
        breakdown.consumption = buyerBreakdown.consumption || breakdown.consumption;
        breakdown.quantity = Math.min(breakdown.quantity || 0, buyerBreakdown.remaining_qty);
      }
    };

    const onItemBreakdownCalculationChange = (itemIndex, breakdownIndex) => {
      // const breakdown = items.value[itemIndex].breakdowns[breakdownIndex];
      // if (breakdown.quantity > breakdown.remaining_qty) {
      //   toast.error(`Quantity cannot exceed remaining quantity (${breakdown.remaining_qty})`);
      //   breakdown.quantity = breakdown.remaining_qty;
      // }

      let totalQty = 0;
      let totalValue = 0;
      items.value[itemIndex].breakdowns.forEach(breakdown => {
        totalQty += Number(breakdown.quantity || 0);
        breakdown.total_price = breakdown.quantity * breakdown.unit_price;
        totalValue += Number(breakdown.total_price || 0);
      });
      items.value[itemIndex].order_quantity = totalQty;
      items.value[itemIndex].total_value = totalValue;
    };

    // const onItemQuantityChange = (i) => {
    //   items.value[i].total_value = (items.value[i].order_quantity * items.value[i].unit_price);
    // };

    const onItemUnitPriceChange = (i) => {
      items.value[i].total_value = (items.value[i].order_quantity * items.value[i].unit_price);
    };

    const addItem = () => {
      items.value.push({
        id:null,
        buyer_order_item_id: null,
        style_id: null,
        order_quantity: 0,
        // unit_price: 0,
        total_value: 0,
        breakdowns: [{
          id:null,
          buyer_order_breakdown_id: null,
          color_id: null,
          size_id: null,
          quantity: 0,
          remaining_qty: 0,
          unit_price: 0,
          total_price:0,
          consumption: 0,
          remaining_qty: 0,
        }]
      });
    };

    const addBreakdown = (i) => {
      
    };

    const removeItem = (itemIndex) => {
    };

    const removeBreakdown = (itemIndex, breakdownIndex) => {
    };

    const submit = handleSubmit((values) => {
      const payload = {
        id: null,
        buyer_order_id: values.buyer_order_id,
        factory_id: values.factory_id,
        allocation_date: values.allocation_date,
        delivery_date: values.delivery_date,
        ex_factory_date: values.ex_factory_date,
        shipment_date: values.shipment_date,
        status: values.status,
        items: items.value.map(i => ({
            id:null,
            buyer_order_item_id: i.buyer_order_item_id,
            style_id: i.style_id,
            order_quantity: i.order_quantity,
            // unit_price: i.unit_price,
            total_value: i.total_value,
            breakdowns: i.breakdowns.map(b => ({ 
                id:null,
                buyer_order_breakdown_id: b.buyer_order_breakdown_id,
                size_id: b.size_id,
                color_id: b.color_id,
                quantity: b.quantity,
                unit_price: b.unit_price,
                total_price: b.unit_price * b.quantity,
                consumption: b.consumption,
            }))
        }))
      };

      if (values.id) {
        store
          .dispatch("updateProductionOrder", { id: values.id, data: payload })
          .then(() => {
              toast.success("Buyer Order Updated Successfully!");
              router.push({ name: "buyer-order-records" });
          })
          .catch((err) => toast.error(err.response?.data?.message));
      } else {
        store
          .dispatch("saveProductionOrder", payload)
          .then(() => {
            toast.success("Buyer Order Created Successfully!");
            router.push({ name: "buyer-order-records" });
          })
          .catch((err) => toast.error(err.response?.data?.message));
      }
    });

    onMounted(() => {
      // Placeholder - functionality to be implemented later
      if (route.params.id) {
        const id = route.params.id;
        isEntryMode.value = false;

        store.dispatch("getProductionOrderById", { id })
          .then((res) => {

            const data = res.data.data;

            setValues({
              id: data.id || null,
              buyer_order_id: data.buyer_order_id,
              factory_id: data.factory_id,
              allocation_date: data.allocation_date,
              delivery_date: data.delivery_date,
              ex_factory_date: data.ex_factory_date,
              shipment_date: data.shipment_date,
              status: data.status,
            });

            items.value = data.items.map(i => ({
              id: i.id,
              buyer_order_item_id: i.buyer_order_item_id,
              style_id: i.style_id,
              order_quantity: i.order_quantity,
              // unit_price: i.unit_price,
              total_value: i.total_value,
              breakdowns: i.breakdowns.map(b => ({
                id: b.id,
                buyer_order_breakdown_id: b.buyer_order_breakdown_id,
                size_id: b.size_id,
                color_id: b.color_id,
                quantity: b.order_quantity,
                remaining_qty: b.remaining_qty,
                unit_price: b.unit_price,
                total_price: b.unit_price * b.quantity,
                consumption: b.consumption,
              }))
            }));

          })
          .catch((error) => {
            console.error(error); // ✅ Dekhar jonno
            toast.error("Failed to load Order");
          });

        
      }
    });

    return {
      panel,
      panel2,
      isEntryMode,
      submit,
      resetForm,
      buyer_order_id,
      factory_id,
      allocation_date,
      ex_factory_date,
      shipment_date,
      submitForm,
      items,
      onBuyerOrderChange,
      onItemChange,
      onBreakdownChange,
      onItemBreakdownCalculationChange,
      // onItemQuantityChange,
      onItemUnitPriceChange,
      addItem,
      addBreakdown,
      removeItem,
      removeBreakdown,
      getAvailableBuyerOrderItems,
      getAvailableBreakdownsForItem,
      getAvailableColorsForItem,
      getAvailableSizesForItem,
      selectedBuyerOrder,
      loadingBuyerOrder,
    };
  },
};
</script>

<style scoped>
.border-thick {
  border-width: 1px !important;
  color: #000;
}
</style>

